import { RootState } from 'shared/store/store';

export const selectLoading = (state: RootState) => state.assignment.loading;
export const selectReading = (state: RootState) => state.assignment.assignment?.assignment?.reading;
export const selectReadingPoints = (state: RootState) => state.assignment.assignment?.assignment?.points;
